import React from 'react'

export default function Nav() {
  return (
    <>
        <div className="single-page-decor"></div>
        <div className="fsp-filter">
            <a className="logo-holder" href="/">
                {/* <img src="styles/images/logo1.png" style={{width:'150px',marginRight:'-200px'}} alt="" /> */}
            </a>
            <nav className="scroll-nav scroll-init d-none d-sm-block">
                <ul>
                    <li><a className="custom-scroll-link act-link" href="#sec1">Home</a></li>
                    <li><a className="custom-scroll-link" href="#sec2">About</a></li>
                    <li><a className="custom-scroll-link" href="#sec3">Service</a></li>
                    <li><a className="custom-scroll-link" href="#sec4">Portfolio</a></li>
                    <li><a className="custom-scroll-link" href="#sec5">Contact</a></li>
                </ul>
            </nav>
        </div>
    </>
  )
}
